export default "__VITE_ASSET__CgmZB24X__"